import { formatPrice } from '@folio/lib';

interface PriceCellProps {
  value: number;
}

export function PriceCell({ value }: PriceCellProps) {
  return formatPrice(value);
}
